import { LAYOUTS, } from "@voltmoney/types";
import { WIDGET, } from "@voltmoney/schema";
import { ROUTE } from "../../routes";
import { ACTION } from "./types";
import { contactUs } from "./actions";
export const template = (height) => ({
    layout: {
        id: ROUTE.FAILED_SCREEN,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true
        },
        widgets: [
            { id: 'failedScreenPage', type: WIDGET.FAILURE_PAGE }
        ],
    },
    datastore: {
        failedScreenPage: {
            height: height,
            title: 'We are facing an unexpected issue',
            subtitle: 'Please try again after some time. If the issue persists, please contact our support.',
            imageUrl: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/ApplicationRejected.svg',
            contactUsAction: {
                routeId: ROUTE.FAILED_SCREEN,
                type: ACTION.CONTACT_US,
                payload: {}
            }
        }
    },
});
export const failedScreenMf = {
    onLoad: async ({ getHeight }) => {
        return Promise.resolve(template(getHeight()));
    },
    actions: {
        [ACTION.CONTACT_US]: contactUs,
    },
};
